module Meevo.Plugins.Employee {
    "use strict";
    /**
    * licensesInsurance Section of Employee
    */
    export class LicensesInsuranceSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.EmployeeLicenseInsurance> {

        public modalService: Components.Modal.IModalService;

        constructor(sectionId: number, displayNameContentKey: string, template: string, isPrimarySection: boolean,
            handlesOwnCrud: boolean, baseEndpoint: string, sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            modalService: Components.Modal.IModalService,
            sectionSecurityKey?: string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun,null,sectionSecurityKey);
            this.modalService = modalService;
        }

        createLicenseInsurance() {
            return this.dataService.getTemplate('Employee', this.parentItemId, "LicensesInsurances")
                .then(result => {
                    result['isValidDate'] = this.isValidDate;
                    console.log('result: ', result);
                    result.auditNoun = this.auditNounForSave;
                    return result;
            })
        }

        isValidDate = (item: any) => {
            if (moment(item.validTo).startOf('day').isBefore(moment(item.validFrom).startOf('day'))) {
                this.modalService.error('Valid to date should be later than valid from date', 0, true)
                    .then(() => {
                        item.validTo = null;
                    })
            }
        }


    }
}